import { useServices } from 'ha/services';
import newReduxTracker from './reduxTracker';

export default function useReduxTracker(): ReturnType<typeof newReduxTracker> {
  const { cookie } = useServices();
  return newReduxTracker(cookie);
}
